var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAccuracyreview(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66 17.9532L6.25333 20.0386L6.59733 22.6346C6.788 24.0746 7.92 25.2079 9.36 25.3999L11.9627 25.7479L14.0467 27.3399C15.2 28.2212 16.7987 28.2212 17.952 27.3399L20.0373 25.7466H20.0347L22.632 25.4026C24.072 25.2119 25.2053 24.0799 25.3973 22.6399L25.744 20.0372C25.744 20.0386 26.5493 18.9839 27.3373 17.9532C28.2187 16.7999 28.2173 15.2012 27.3373 14.0479L25.7467 11.9612L25.4027 9.36524C25.212 7.92524 24.08 6.79191 22.64 6.59991L20.036 6.25324L17.952 4.66124C16.7987 3.77991 15.2 3.77991 14.0467 4.66124L11.9613 6.25324H11.964L9.36667 6.59858C7.92667 6.78924 6.79333 7.92124 6.60133 9.36124L6.25333 11.9639C6.25333 11.9626 5.448 13.0172 4.66 14.0479C3.78 15.1999 3.78 16.7999 4.66 17.9532V17.9532Z",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M19.7376 14.136L15.0696 18.804L12.2656 16.0027",
    stroke: "#202020",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccuracyreview);
export default __webpack_public_path__ + "static/media/accuracyreview.7e403980f2dc927640a4e42444ac1da7.svg";
export { ForwardRef as ReactComponent };